import React from "react";
import { VariantBase } from "scmp-sdk/components/newsletter/newsletter-widget/variants/component";

import { Container, theme } from "./styles";

export { config as newsletterListThemeConfig } from "./config";

export const NewsletterListTheme: React.FunctionComponent<{ children?: React.ReactNode }> = ({
  children,
  ...props
}) => (
  <VariantBase theme={theme}>
    <Container {...props}>{children}</Container>
  </VariantBase>
);

NewsletterListTheme.displayName = "NewsletterListTheme";
